import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

jQuery(document).ready(function(){
    // mobile menu
    $('.menu-btn').click(function() {
        if ($(window).width() < 768) {
            $('.main-header-navigation-container').toggleClass('open-menu');
            $(this).toggleClass('burger_active');
            $('#menu-main-menu-1').fadeToggle();
        }
    });

    $('.menu-item').click(function() {
        if ($(window).width() < 768) {
            $('.main-header-navigation-container').removeClass('open-menu');
            $('.menu-btn').removeClass('burger_active');
            $('#menu-main-menu-1').fadeOut();
        }
    });



    // sticky header
    $(window).scroll(function(){
        if ($(window).scrollTop() >= 200) {
            $('.main-header-navigation').addClass('sticky-header');
            if ($(window).width() < 768) {
                $('.main-header-navigation-container').addClass('sticky-header-mobile');
            }
            $('.contact-btn').css('display', 'block');
        }
        else {
            $('.main-header-navigation').removeClass('sticky-header');
            if ($(window).width() < 768) {
                $('.main-header-navigation-container').removeClass('sticky-header-mobile');
            }
            $('.contact-btn').css('display', 'none');
            /*$('#contact-btn').animate({
                width: '185px',
                height: '59px',
                top: '58px'
            });*/
            $('#btn-1, #btn-2, #btn-3, #btn-x').remove();
        }
    });

    let contactBtn = "<div class=\"contact-btn\"><p>Kontakt</p></div>";
    if ($(window).width() > 769) {
        $(".call-class").after(contactBtn);
    }
    if ($(window).width() < 768) {
        $(".main-header-navigation-container").append(contactBtn);
    }

    let companyPhone = $('#company-phone').text();
    let companyPhoneHref = $('#company-phone').attr('href');
    let companyMail = $('#company-mail').text();
    console.log(companyPhone, companyMail);
    $('.contact-btn').click(function() {
        $(this).addClass('open-contact-btn');

        $(this).after('<a id="btn-1" href="#jetzt-anmelden" class="btn-white">Kontaktformular ausfüllen</a>');
        $(this).after('<a id="btn-2"  href="" class="btn-transparent fb-pixel-contact" >'+ companyPhone + '</a>');
        $('#btn-2').attr('href', companyPhoneHref);
        $(this).after('<a id="btn-3"  href="" class="btn-transparent fb-pixel-contact" >E-Mail</a>');
        $('#btn-3').attr('href', 'mailto:' + companyMail);
        $(this).after('<a id="btn-x"></a>');

        $('#btn-1, #btn-x').click(function() {
            $('#btn-1, #btn-2, #btn-3, #btn-x').remove();
            $('.contact-btn').removeClass('open-contact-btn');
        });

        $('#btn-2, #btn-3').click(function(e) {
            console.log('check');
            fbq('track', 'Contact');
            $('#btn-1, #btn-2, #btn-3, #btn-x').remove();
            $('.contact-btn').removeClass('open-contact-btn');
        });

    });


    // header form btn
    $('#header-form-open-btn').click(function() {
        $('#header-form').slideDown('slow');
        if ($(window).width() < 615) {
            $('#header-form').prepend('<h2 id="header-form-mobile-title" class="text-center">Jetzt anfragen</h2>');
            $('#frm_form_4_container').after('<a id="header-form-close-mobile" class="btn-transparent header-form-close-mobile-btn">Schliessen</a>');

            $('#header-form-close-mobile').click(function() {
                $('#header-form-close-mobile').remove();
                $('#header-form').slideUp('slow');
                $('#header-form-mobile-title').remove();
            });
        }
    });


    let closeId = "<div id='header-form-close'></div>";
    $("#frm_field_26_container").after(closeId);

    $('#header-form-close').click(function() {
        console.log('do')
        $('#header-form').slideUp('slow');
    });

    // footer form

    $('#jetzt-anmelden').find('.frm_submit').append('<a href="" id="subscribePhone" class="btn-red-transparent btn-footer fb-pixel-contact">'+ companyPhone+ '</a>');
    $('#subscribePhone').attr('href', companyPhoneHref);
    $('#jetzt-anmelden').find('.frm_submit').append('<a href="" id="subscribeMail" class="btn-red-transparent btn-footer fb-pixel-contact">E-Mail</a>');
    $('#subscribeMail').attr('href', 'mailto:' + companyMail);


    // post page
    $('.post').fadeIn('4500');
    $('.btn-close-x').click(function () {
        $('.post-container').fadeOut('slow');
    })



    //swiper sliders
    var themenSwiper = new Swiper ('.swiper-themen', {
        // Optional parameters
        loop: true,
        autoHeight: true,

        // If we need pagination
        pagination: {
            el: '.swiper-themen-pagination',
            type: 'fraction',
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-themen-button-next',
            prevEl: '.swiper-themen-button-prev',
        },

        fadeEffect: {
            crossFade: false
        },

    });

    var blogSwiper = new Swiper ('.swiper-blog', {
        // Optional parameters
        slidesPerView: 1,
        spaceBetween: 20,
        direction: 'horizontal',
        //loop: true,

        // If we need pagination
        pagination: {
            el: '.swiper-red-pagination',
            type: 'fraction',
        },

        breakpoints: {
            480: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-red-next',
            prevEl: '.swiper-button-red-prev',
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });

    var testimonialSwiper = new Swiper ('.swiper-testimonial', {
        // Optional parameters
        slidesPerView: 1,
        direction: 'horizontal',
        spaceBetween: 10,
        centeredSlides: true,
        loop: true,

        // If we need pagination
        pagination: {
            el: '.swiper-red-pagination',
            type: 'fraction',
        },

        breakpoints: {
            480: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            680: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
        },

        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-red-next',
            prevEl: '.swiper-button-red-prev',
        },

        // And if we need scrollbar
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    })


// fb pixel events
    // fbqScript
    var fbqScript = "<script>" +
        "fbq('track', 'Lead', {" +
        " value: 1," +
        " currency: 'CHF'," +
        "});" + "</script>";
    $('.frm_message').append(fbqScript);
    var linkedinCode = "<img height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"https://px.ads.linkedin.com/collect/?pid=2027850&conversionId=2211986&fmt=gif\" />";
    $('.frm_message').append(linkedinCode);


    $('.frm_button_submit').click(function() {
        console.log('check');
        fbq('track', 'Lead', {
            value: 0,
            currency: 'CHF',
        });
        var linkedinCode = "<img height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"https://px.ads.linkedin.com/collect/?pid=2027850&conversionId=2211986&fmt=gif\" />";
        $(this).append(linkedinCode);
    });

    $('#header-form-open-btn').click(function() {
        console.log('check');
        fbq('track', 'InitiateCheckout', {
            value: 0,
            currency: 'CHF',
        });
        var linkedinCode = "<img height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"https://px.ads.linkedin.com/collect/?pid=2027850&conversionId=2230378&fmt=gif\" />";
        $(this).append(linkedinCode);
    });

    $('.menu-item-27').click(function() {
        console.log('check');
        fbq('track', 'InitiateCheckout', {
            value: 0,
            currency: 'CHF',
        });
        var linkedinCode = "<img height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"https://px.ads.linkedin.com/collect/?pid=2027850&conversionId=2230378&fmt=gif\" />";
        $(this).append(linkedinCode);
    });



    $('.fb-pixel-preis').click(function() {
        console.log('check');
        fbq('track', 'AddToCart', {
            value: 0,
            currency: 'CHF',
        });
    });

    $('.fb-pixel-contact').click(function() {
        console.log('check');
        fbq('track', 'Contact');
    });

    $('#btn-1').click(function(e) {
        console.log('check-oben');

    });

    $('#btn-2').click(function(e) {
        console.log('check');
        fbq('track', 'Contact');

    });

    $('#btn-3').click(function(e) {
        console.log('check');
        fbq('track', 'Contact');

    });
});